// extracted by mini-css-extract-plugin
module.exports = {"businessName":"styles_businessName__1-Z8F","lastRow":"styles_lastRow__qg2-x","hasAnInternshipAgreement":"styles_hasAnInternshipAgreement__bOW7r"};